module.exports = "import React from 'react';\n\nimport { Layer, Frame, Drag } from 'buttery';\n\nexport default class Example extends React.Component {\n  render() {\n    return (\n      <div>\n        <Layer\n          frame={Frame(Drag(160), Drag(160), 80, 80)}\n          style={{\n            backgroundColor: '#49c6ae',\n          }}\n        />\n      </div>\n    );\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/sections/04-Drag/App.js
// module id = 252
// module chunks = 0